import * as React from "react";
import { Gender } from "../../../../../../react-core/Enums/Gender";
import { BankAccountOwner } from "../../../../../../Wrap/Constants/Enums/Domain/BankAccountOwner";
import { MaritalStatus } from "../../../../../../Wrap/Constants/Enums/Domain/MaritalStatus";
import { Frequency } from "../../../../../../Wrap/Constants/Enums/Domain/Frequency";
import { ClientRegularPayment } from "../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/ClientRegularPayment";
import { CurrencyCode } from "../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { ClientSinglePayment } from "../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/ClientSinglePayment";
import { ThirdPartyPaymentModel } from "../../../../../../Wrap/Models/Models/Shared/ThirdPartyPaymentModel";
import { DepositMethod } from "../../../../../../Wrap/Constants/Enums/Domain/DepositMethod";
import { SourceOfWealthOption } from "../../../../../../Wrap/Constants/Enums/Apply/SourceOfWealthOption";
import { ThirdPartyType } from "../../../../../../Wrap/Constants/Enums/ThirdPartyType";
import { CustomerStatus } from "../../../../../../Wrap/Constants/Enums/Domain/CustomerStatus";
import { MoneyPurchaseAnnualAllowanceSource } from "../../../../../../Wrap/Constants/Enums/Apply/MoneyPurchaseAnnualAllowanceSource";
import { RegularDepositMethod } from "../../../../../../Wrap/Constants/Enums/Domain/RegularDepositMethod";
import { DirectDebitMethod } from "../../../../../../Wrap/Constants/Enums/Domain/DirectDebitMethod";
import { PensionTransfer } from "../../../../../../Wrap/Models/Models/Processes/Quote/Pension/PensionTransfer";
import { TransferType } from "../../../../../../Wrap/Constants/Enums/Domain/TransferType";
import { DisinvestmentStrategyType } from "../../../../../../Wrap/Constants/Enums/Client/DisinvestmentStrategyType";
import { UserClaim } from "../../../../../../Wrap/Constants/Enums/UserClaim";
import { Permission } from "../../../../../Shared/Permission/Permission";
import { SourceOfFunds } from "../../../../../../Wrap/Constants/Enums/Payments/SourceOfFunds";
import { ExternalPensionTransferRecommendation } from "../../../../../../Wrap/Constants/Enums/Transfer/ExternalPensionTransferRecommendation";
import { DrawdownType } from "../../../../../../Wrap/Constants/Enums/Drawdown/DrawdownType";

export interface TransferOrDrawdown extends PensionTransfer {
    PensionTransfersIndex?: number;
    IsInternal?: boolean;
}

export const MaxGiaCount = 5;

export const NBSteppers = {
    fullClientDetail: "Full client details",
    wrapperSelection: "Wrapper selection",
    paymentsIn: "Payments in",
    adviserCharges: "Adviser charges",
    investmentSelection: "Investment selection",
    incomePaymentDetails: "Income payment details",
    disinvestmentStrategy: "Disinvestment strategy",
    review: "Review",
    doc: "Documents & declarations",
    regularWithdrawals: "Regular withdrawal",
    drawdownDetail: "Drawdown detail",
    comfirmation: "Confirmation",
    withdrawal: "Withdrawals",
    SIPP: "Aberdeen SIPP",
    JSIPP: "JSIPP",
    ISA: "ISA Stocks & Shares",
    PP: "Personal Portfolio",
    wrapCash: "Cash Account",
    openBondInLegacyWizard: "Open Onshore/Offshore bond",
    legacyWizard: "New business existing client",
    legacyProduct: "SIPP & Bond detail",
    additionalProductDetails: "Additional product details",
};

export const regularDepositMethodArrays = [
    RegularDepositMethod.Cheque,
    RegularDepositMethod.BACS,
    RegularDepositMethod.DirectDebit,
    RegularDepositMethod.ProductWrapperCash,
];

export const regularDepositMethodArraysMap = {
    [RegularDepositMethod.Cheque]: "Cheque",
    [RegularDepositMethod.BACS]: "BACS/CHAPS",
    [RegularDepositMethod.DirectDebit]: "Direct Debit",
    [RegularDepositMethod.ProductWrapperCash]: "Wrap Cash",
};

export const depositMethodArrays = [
    DepositMethod.Cheque,
    DepositMethod.BACS,
    DepositMethod.DirectDebit,
    DepositMethod.WrapCash,
];
export const depositMethodArraysMap = {
    [DepositMethod.Cheque]: "Cheque",
    [DepositMethod.BACS]: "BACS/CHAPS",
    [DepositMethod.DirectDebit]: "Direct Debit",
    [DepositMethod.WrapCash]: "Cash Account",
};

export const DisinvestmentStrategyTypeArray = [
    DisinvestmentStrategyType.Proportional,
    DisinvestmentStrategyType.Lifo,
    DisinvestmentStrategyType.LVS,
];

export const DisinvestmentStrategyTypeStringMap = (label: string) => {
    switch (label.toLowerCase()) {
        case "proportional":
            return DisinvestmentStrategyType.Proportional;
        case "lvs":
            return DisinvestmentStrategyType.LVS;
        case "lifo":
            return DisinvestmentStrategyType.Lifo;
        default:
            return DisinvestmentStrategyType.Proportional;
    }
};

export const FrequencyTypeArrays = [Frequency.Monthly, Frequency.Quarterly, Frequency.HalfYearly, Frequency.Yearly];

export const FrequencyArraysMap = {
    [Frequency.Monthly]: "Monthly",
    [Frequency.Quarterly]: "Quarterly",
    [Frequency.HalfYearly]: "Half yearly",
    [Frequency.Yearly]: "Yearly",
};
export const BankAccountOwnerArrays = [
    BankAccountOwner.Individual,
    BankAccountOwner.Partner,
    BankAccountOwner.Joint,
    BankAccountOwner.Employer,
    BankAccountOwner.ThirdParty,
];

export const BankAccountOwnerMap = {
    [BankAccountOwner.Individual]: "Individual",
    [BankAccountOwner.Partner]: "Partner",
    [BankAccountOwner.Joint]: " Joint",
    [BankAccountOwner.Employer]: "Employer",
    [BankAccountOwner.ThirdParty]: "Third-party",
};

export const AdviceType = [
    {
        key: "nonDiscretionary",
        value: "Non-discretionary",
    },
    {
        key: "Discretionary",
        value: "Discretionary",
    },
];

export const GenderOptions = [Gender.Male, Gender.Female];
export const GuardianGenderOptions = [Gender.Male, Gender.Female];

export const GenderOptionsMap = {
    [Gender.Male]: "Male",
    [Gender.Female]: "Female",  
};

export const CustomerStatuses = {
    title: "Customer Status",
    options: [CustomerStatus.Active, CustomerStatus.Inactive, CustomerStatus.Deceased],
    optionsMap: {
        [CustomerStatus.Active]: "Active",
        [CustomerStatus.Inactive]: "Inactive",
        [CustomerStatus.Deceased]: "Deceased",
    },
};

export const Marital = {
    title: "Marital status",
    options: [
        MaritalStatus.Single,
        MaritalStatus.MarriedOrCivilPartner,
        MaritalStatus.Separated,
        MaritalStatus.Divorced,
        MaritalStatus.Widowed,
    ],
    optionsMap: {
        [MaritalStatus.Divorced]: "Divorced / Dissolved civil partnership",
        [MaritalStatus.MarriedOrCivilPartner]: "Married / Civil partnership",
        [MaritalStatus.Single]: "Single",
        [MaritalStatus.Separated]: "Separated",
        [MaritalStatus.Widowed]: "Widowed / Surviving civil partner",
    },
};

export const emptyClientRegularPayment: ClientRegularPayment = {
    Frequency: Frequency.Monthly,
    Money: { Amount: null, Currency: CurrencyCode.GBP },
    IsContinue: null,
    ContinueUntil: null,
    FirstCollectionDate: null,
};

export const emptyClientSinglePayment: ClientSinglePayment = {
    BankAccountNumber: null,
    Money: { Amount: null, Currency: CurrencyCode.GBP },
    PaymentMethod: null,
    PaymentDate: null,
};

export const emptyThirdPartyRegularPayment: ThirdPartyPaymentModel = {
    Money: { Amount: null, Currency: CurrencyCode.GBP },
    Frequency: Frequency.Monthly,
    IsContinue: null,
    ContinueUntil: null,
    FirstCollectionDate: null,
};

export const emptyThirdPartySinglePayment: ThirdPartyPaymentModel = {
    Money: { Amount: null, Currency: CurrencyCode.GBP },
    PaymentMethod: null,
    PaymentDate: null,
};

export const DrawdownTypeMap = {
    [DrawdownType.Capped]: "Capped",
    [DrawdownType.Flexible]: "Flexi"
}

export const ExternalPensionTransferRecommendationArrayGeneral = [
    ExternalPensionTransferRecommendation.OnPlatformRecommendation,
    ExternalPensionTransferRecommendation.NoRecommendation
];

export const ExternalPensionTransferRecommendationArrayInclude3rdParty = [
    ExternalPensionTransferRecommendation.OnPlatformRecommendation,
    ExternalPensionTransferRecommendation.NoRecommendation,
    ExternalPensionTransferRecommendation.ThirdPartyAdvisorRecommendation
];

export const ExternalPensionTransferRecommendationArrayMap = {
    [ExternalPensionTransferRecommendation.OnPlatformRecommendation]: "Yes",
    [ExternalPensionTransferRecommendation.NoRecommendation]: "No",
    [ExternalPensionTransferRecommendation.ThirdPartyAdvisorRecommendation]: "3rd Party Adviser",
};

export class ContentsTable {
    public static None = "None";
    public static DirectDebitMethodInformation1 =
        "An online Direct Debit can only be set up if the client is present at the point the bank details are entered.";
    public static DirectDebitMethodInformation2 =
        "If the client is not present you can still enter the bank details here but you must obtain a signed Direct Debit form from the client and send it to us.";
    public static DirectDebitMethodInformation3 =
        "In that case, we will not start making Direct Debit collections until we have received the signed form";
    public static DirectDebitMethodInformation4 =
        "A Direct Debit mandate is already in force for this client and therefore we can begin collections from this bank account without needing a further instruction from your client.";
}

export const MoneyPurchaseAnnualAllowanceSourceArray = [
    MoneyPurchaseAnnualAllowanceSource.NotSpecified,
    MoneyPurchaseAnnualAllowanceSource.UncrystallisedFundsPcls,
    MoneyPurchaseAnnualAllowanceSource.StandaloneLumpSum,
    MoneyPurchaseAnnualAllowanceSource.FlexiAccessIncomePayment,
];

export const MoneyPurchaseAnnualAllowanceSourceArrayMap = {
    [MoneyPurchaseAnnualAllowanceSource.NotSpecified]: "Unknown",
    [MoneyPurchaseAnnualAllowanceSource.UncrystallisedFundsPcls]: "Uncrystallised pension saving lump sum payment",
    [MoneyPurchaseAnnualAllowanceSource.StandaloneLumpSum]: "Standalone lump sum payment",
    [MoneyPurchaseAnnualAllowanceSource.FlexiAccessIncomePayment]: "Flexible-access drawdown payment",
};

export const SourceOfWealthArray = [
    SourceOfWealthOption.ArmsDefenseMilitary,
    SourceOfWealthOption.CannabisProduction,
    SourceOfWealthOption.CompanyProfitsDividends,
    SourceOfWealthOption.CompensationPayment,
    SourceOfWealthOption.DataMissingNotAvailable,
    SourceOfWealthOption.DivorceSettlement,
    SourceOfWealthOption.EmployerContributions,
    SourceOfWealthOption.Gambling,
    SourceOfWealthOption.Gift,
    SourceOfWealthOption.Inheritence,
    SourceOfWealthOption.ISATransfer,
    SourceOfWealthOption.LotteryBettingWin,
    SourceOfWealthOption.PaymentServiceProvider,
    SourceOfWealthOption.PensionTransfer,
    SourceOfWealthOption.PolicyClaimMaturity,
    SourceOfWealthOption.PreciousMetalsStones,
    SourceOfWealthOption.RedLightBusinessAE,
    SourceOfWealthOption.SalaryBonus,
    SourceOfWealthOption.SaleofCompany,
    SourceOfWealthOption.SaleofInvestments,
    SourceOfWealthOption.SaleofProperty,
    SourceOfWealthOption.Savings,
    SourceOfWealthOption.SupplyorInvestment,
    SourceOfWealthOption.VirtualCurrencies,
];

export const SourceOfWealthArrayMap = {
    [SourceOfWealthOption.ArmsDefenseMilitary]: "Arms/Defense/Military",
    [SourceOfWealthOption.CannabisProduction]: "Cannabis Production",
    [SourceOfWealthOption.CompanyProfitsDividends]: "Company Profits/Dividends",
    [SourceOfWealthOption.CompensationPayment]: "Compensation Payment",
    [SourceOfWealthOption.DataMissingNotAvailable]: "Data Missing/Not Available",
    [SourceOfWealthOption.DivorceSettlement]: "Divorce Settlement",
    [SourceOfWealthOption.EmployerContributions]: "Employer Contributions",
    [SourceOfWealthOption.Gambling]: "Gambling",
    [SourceOfWealthOption.Gift]: "Gift",
    [SourceOfWealthOption.Inheritence]: "Inheritence",
    [SourceOfWealthOption.ISATransfer]: "ISA Transfer",
    [SourceOfWealthOption.LotteryBettingWin]: "Lottery/Betting Win",
    [SourceOfWealthOption.PaymentServiceProvider]: "Payment Service Provider",
    [SourceOfWealthOption.PensionTransfer]: "Pension Transfer",
    [SourceOfWealthOption.PolicyClaimMaturity]: "Policy Claim/Maturity",
    [SourceOfWealthOption.PreciousMetalsStones]: "Precious Metals/Stones",
    [SourceOfWealthOption.RedLightBusinessAE]: "Red Light Business/Adult Entertainment",
    [SourceOfWealthOption.SalaryBonus]: "Salary/Bonus",
    [SourceOfWealthOption.SaleofCompany]: "Sale of Company",
    [SourceOfWealthOption.SaleofInvestments]: "Sale of Investments",
    [SourceOfWealthOption.SaleofProperty]: "Sale of Property",
    [SourceOfWealthOption.Savings]: "Savings",
    [SourceOfWealthOption.SupplyorInvestment]: "Supply or Investment",
    [SourceOfWealthOption.VirtualCurrencies]: "Virtual Currencies",
};

export const SourceOfFundsArray = [
    SourceOfFunds.ArmsDefenseMilitary,
    SourceOfFunds.CannabisProduction,
    SourceOfFunds.CompanyProfitsDividends,
    SourceOfFunds.CompensationPayment,
    SourceOfFunds.DataMissingNotAvailable,
    SourceOfFunds.DivorceSettlement,
    SourceOfFunds.EmployerContributions,
    SourceOfFunds.Gambling,
    SourceOfFunds.Gift,
    SourceOfFunds.Inheritence,
    SourceOfFunds.ISATransfer,
    SourceOfFunds.LotteryBettingWin,
    SourceOfFunds.PaymentServiceProvider,
    SourceOfFunds.PensionTransfer,
    SourceOfFunds.PolicyClaimMaturity,
    SourceOfFunds.PreciousMetalsStones,
    SourceOfFunds.RedLightBusinessAE,
    SourceOfFunds.SalaryBonus,
    SourceOfFunds.SaleofCompany,
    SourceOfFunds.SaleofInvestments,
    SourceOfFunds.SaleofProperty,
    SourceOfFunds.Savings,
    SourceOfFunds.SupplyorInvestment,
    SourceOfFunds.VirtualCurrencies,
];

export const SourceOfFundsArrayMap = {
    [SourceOfFunds.ArmsDefenseMilitary]: "Arms/Defense/Military",
    [SourceOfFunds.CannabisProduction]: "Cannabis Production",
    [SourceOfFunds.CompanyProfitsDividends]: "Company Profits/Dividends",
    [SourceOfFunds.CompensationPayment]: "Compensation Payment",
    [SourceOfFunds.DataMissingNotAvailable]: "Data Missing/Not Available",
    [SourceOfFunds.DivorceSettlement]: "Divorce Settlement",
    [SourceOfFunds.EmployerContributions]: "Employer Contributions",
    [SourceOfFunds.Gambling]: "Gambling",
    [SourceOfFunds.Gift]: "Gift",
    [SourceOfFunds.Inheritence]: "Inheritence",
    [SourceOfFunds.ISATransfer]: "ISA Transfer",
    [SourceOfFunds.LotteryBettingWin]: "Lottery/Betting Win",
    [SourceOfFunds.PaymentServiceProvider]: "Payment Service Provider",
    [SourceOfFunds.PensionTransfer]: "Pension Transfer",
    [SourceOfFunds.PolicyClaimMaturity]: "Policy Claim/Maturity",
    [SourceOfFunds.PreciousMetalsStones]: "Precious Metals/Stones",
    [SourceOfFunds.RedLightBusinessAE]: "Red Light Business/Adult Entertainment",
    [SourceOfFunds.SalaryBonus]: "Salary/Bonus",
    [SourceOfFunds.SaleofCompany]: "Sale of Company",
    [SourceOfFunds.SaleofInvestments]: "Sale of Investments",
    [SourceOfFunds.SaleofProperty]: "Sale of Property",
    [SourceOfFunds.Savings]: "Savings",
    [SourceOfFunds.SupplyorInvestment]: "Supply or Investment",
    [SourceOfFunds.VirtualCurrencies]: "Virtual Currencies",
};

export const ThirdPartyTypeArray = [
    ThirdPartyType.Individual,
    ThirdPartyType.Trust,
    ThirdPartyType.Charity,
    ThirdPartyType.Corporate,
    ThirdPartyType.ClubOrAssociation,
];

export const ThirdPartyTypeArrayMap = {
    [ThirdPartyType.Individual]: "Individual (includes spouse)",
    [ThirdPartyType.Trust]: "Trust",
    [ThirdPartyType.Charity]: "Charity",
    [ThirdPartyType.Corporate]: "Corporate",
    [ThirdPartyType.ClubOrAssociation]: "Club/association",
};

export const PayeeType = {
    Client: "Client",
    ThirdParty: "Third party",
    Employer: "Employer",
};

export const BankAccountOwnerPayeeTypeMap = {
    [BankAccountOwner.Individual]: [PayeeType.Client],
    [BankAccountOwner.Joint]: [PayeeType.Client],
    [BankAccountOwner.Partner]: [PayeeType.Client],
    [BankAccountOwner.Employer]: [PayeeType.Employer, PayeeType.Client],
    [BankAccountOwner.ThirdParty]: [PayeeType.ThirdParty],
};

export const DirectDebitMethodArray = [DirectDebitMethod.Online, DirectDebitMethod.Paper];

export const DirectDebitMethodArrayMap = {
    [DirectDebitMethod.Online]: "Online",
    [DirectDebitMethod.Paper]: "Paper",
};

export const ContinueUntil = ["Until notified", "Until date"];

export const DirectDebitOptionsLabels = {
    directDebitOptionsInfoText:
        "An online Direct Debit can only be set up if the client is present at the point the bank details are entered. If the client is not present you can still enter the bank details here but you must obtain a signed Direct Debit form from the client and send it to us. In that case, we will not start making Direct Debit collections until we have received the signed form",
    directDebitAcceptTerms: "I confirm that I understand and agree to the Online Direct Debit terms",
    directDebitRequiredTerms: "You must complete the required declaration",
};

export const nbSippIncomePaymentDetailsLabels = {
    regularIncomePayment: "Regular income payment",
    taxableIncomeRequiredInAddition: "Is taxable income required in addition to the tax-free lump sum?",
    targetSpecificArrangements: "Do you wish to target specific arrangements?",
    targetSpecificArrangementsTooltip: "Where a customer has more than one drawdown arrangement, you are able to choose which arrangements are used to provide income withdrawals. Selecting specific arrangements can be beneficial for clients who have inherited drawdown benefits which have different tax treatments. Or you can select 'No' and the platform will automatically choose the arrangements to be used.",
    takeDifferentInitialIncomePaymentTooltip: "We offer a different initial income payment; this could be used to take a one-off taxable withdrawal or an alternative first payment followed by a regular income payment of a different amount.",
    takeDifferentInitialIncomePayment: "Do you wish to take a different initial income payment?",
    grossInitialIncomePayment: "Gross initial income payment",
    maximumInitialIncomePayment: "Maximum for initial income payment",
    maximumIncomePerPayment: "Maximum income per payment",
    maximumAvailablePerPayment: "Maximum available per payment",
    grossIncomePerPayment: "Gross income per payment",
    grossIncomePerPaymentFromPension: "Gross income per payment from the pension",
    incomeFrequency: "Income frequency",
    firstPaymentDate: "First payment date",
    endDate: "End date",
    untilNotified: "Until notified",
    enterADate: "Enter a date",
    calculateEstimatedPaye: "Calculate estimated PAYE",
    estimatedPayeTax: "Estimated PAYE tax",
    estimatedNetPayment: "Estimated net payment",
    taxCode: "Tax Code",
    taxBasis: "Basis",
    oneOffIncomePayment: "One-off income payment",
    takeOneOffIncomePayment: "Do you wish to take a one-off income payment?",
    maximumGrossOneOffIncomePayment: "Maximum gross one-off income payment",
    crystallisation: "Drawdown",
    capped: "Capped",
    flexi: "Flexible",
    from: "From",
    amount: "Amount",
    type: "Type",
    member: "Member",
    inherited: "Inherited",
    gadMaximum: "GAD maximum",
    incomeTakenToDate: "Income taken to date",
    lastMandatoryReview: "Last mandatory review",
    maximumIncomePaymentForRemainderOfYear: "Maximum income payment for remainder of pension year",
    maximumIncomePaymentForFutureYears: "Maximum income payment for future pension years",
    incomePerPaymentForCurrentPensionYear: "Income per payment for current pension year",
    incomePerPaymentForFuturePensionYears: "Income per payment for future pension years",
    MaximumIncomePerPayment: "Maximum income payment per payment",
    incomePerPayment: "Income per payment",
    takeFullValue: "Take full value",
    flexiArrangementsExhausted: "Please tick to confirm your client understands this and is happy to proceed",
    chooseAssetSelectionMethod: "Choose asset selection method",
    proportionallyAcrossAllAssets: "Proportionally across all assets",
    fromSpecifiedAssets: "From specified assets",
    chooseAssetsHeader: "Disinvestment from post-retirement to meet income payments",
    nextYearsGadMaximum: "Next years GAD maximum",
    cappedPlusFlexiTotals: "Capped plus flexible totals",
    nextFlexiReviewDate: "Next flexible income review date",
    frequencyOfFlexiIncomeReview: "Frequency of flexible income review",
    paymentMethod: "Payment method",
    investment: "Investment",
    currentUnitsHeld: "Current units held",
    currentEstimatedValue: "Current estimated value",
    estimatedValueToSell: "Estimated value to sell",
    sumOfValueToSell: "Percentage of income payment (total)",
    selectBankAccount: "Select bank account",
    splitAcrossTwoBankAccounts: "Split across two bank accounts",
    bankAccount1: "Bank account 1",
    bankAccount2: "Bank account 2",
    addBankAccount: "Add bank account",
    portionOfPcls: "Portion of PCLS",
    proportionOfIncome: "Proportion of income",
    bankAccountNotValidated:
        "Please note this bank account is not validated - it must have been validated by the time we do the drawdown.",
};

export const nbSippIncomePaymentDetailsMessages = {
    grossInitialIncomePaymentRequired: "Please enter gross initial income payment",
    grossIncomePerPaymentRequired: "Please enter gross income per payment",
    grossIncomePerPaymentFromPensionRequired: "Please enter gross income per payment from the pension",
    incomeFrequencyRequired: "Please enter income frequency",
    firstPaymentDateRequired: "Please enter first payment date",
    enterADateRequired: "Please enter a date",
    oneOffIncomePaymentRequired: "Please enter one-off income payment",
    incomePerPaymentForCurrentPensionYearRequired: "Please enter income per payment for current pension year",
    incomePerPaymentForFuturePensionYearsRequired: "Please enter income per payment for future pension years",
    incomePerPaymentRequired: "Please enter income per payment",
    flexiArrangementsExhausted:
        "The income specified will exhaust one or more of your client's flexible drawdown arrangements within a year.",
    messagesGrossInitialIncomeOver: "Gross initial income payment must not be greater than maximum",
    grossIncomePerPaymentOver:
        "Please enter an income amount that is greater than zero and less than or equal to the maximum income per payment.",
    grossAvailablePerPaymentOver:
        "Please enter an income amount that is greater than zero and less than or equal to the maximum available per payment.",
    firstPaymentDateUnder15: "The date selected must be at least 15 working days from today",
    firstPaymentDateUnder10: "The date selected must be at least 10 working days from today",
    endDateUnder: "End date must be equal to or later than the first payment date",
    dateOver28: "Date must be between 1-28 of the month",
    standardAlgorithmCappedMessage:
        "Where income is being taken from Capped drawdown, the amount available will be subject to the maximum annual limits. The maximum income may be less than shown where drawdown benefits have been transferred to the Aberdeen SIPP and withdrawals have been taken from the previous scheme.",
    inheritedFundMessage:
        "This Aberdeen SIPP plan includes an inherited drawdown arrangement(s). Remember, you can use the ‘target specific arrangements’ option should you wish to include or exclude these arrangements when making withdrawals.",
    etiProRataMessage: "SL TO CONFIRM MESSAGE",
    percentageOver100: "value can't exceed 100%",
    percentageUnder0: "At least 0%",
    not100PercentMessage:
        "Please enter values against the assets from which the income payment will be made that total 100%",
    cannotBeGreaterThanMaximumIncomePaymentForRemainderOfYear:
        "Income per payment for current pension year cannot be more than the maximum",
    cannotBeGreaterThanMaximumIncomePaymentForFutureYears:
        "Income per payment for future pension years cannot be more than the maximum",
    cannotBeGreaterThanMaximumPerIncomePayment: "Income per payment cannot be more than maximum",
    nextFlexiReviewDateRequired: "Please enter next flexible income review date",
    nextFlexiReviewDateUnder: "Date must be 20 days or more in the future",
    nextFlexiReviewDateMoreThan3Year:
        "Income review date is more than 3 years in the future. Please confirm this is correct",
    frequencyOfFlexiIncomeReviewUnderOver: "Frequency must be between 1 and 60",
    frequencyOfFlexiIncomeFrequencyRequired: "The frequency if reviews must be entered",
    totalPortionOfPCLSNot100: "Total portion of PCLS must be 100%",
    totalProportionOfIncomeNot100: "Total proportion of income must be 100%",
    grossIncomeNotSumOfArrangementsIncome: "Total of arrangements income must equal gross income",
};

export const nbPaymentsInMessages = {
    atLeastOneContribution:
        "Please make a contribution to this product wrapper to continue. To remove this product type, please navigate back to the wrapper selection step",
};

export const WrapperSelectionContents = {
    clientNameMessage: (firstName: string, middleName: string, familyName: string) =>
        `${firstName} ${middleName || ""} ${familyName} has been successfully added as a client`,
};

export const NewTpsInvestmentsMessage = {
    messagePart1: "To proceed into a TPS Model, you must ensure a mandate is set up via the ",
    messagePart2: " page once the sub account is active.",
    link: (
        <Permission
            userClaim={UserClaim.AdviserPortalDluMandatesSearchCanView}
            replaceChildren={"Setup and search mandate"}
        >
            <a className="inline-link" target="_blank" href="/mandates/searchandsetup/search.aspx">
                Setup and search mandate
            </a>
        </Permission>
    ),
};

// @TODO Once pension calculation service is completed, need to change to real data
export const maximumIncomePaymentForRemainderOfYear = 100;
export const maximumIncomePaymentForFutureYears = 83.33;
export const maximumIncomePerPayment = 57620.75;
export const nextYearsGadMaximum = 1000;
// End @TODO Once pension calculation service is completed, need to change to real data

export const PaymentInMessage = {
    sourceOfFundsToolTip:
        "Provide the source of funds from which the money has been obtained. This is not the bank account where the money has come from",
};
